import React from 'react';
import { css, cx } from '@emotion/css';

interface ListProps extends React.HTMLAttributes<HTMLUListElement> {}

interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  block?: boolean;
}

export const AccessibleList = ({ className, children, ...rest }: ListProps) => (
  <ul className={cx(listStyle, className)} {...rest}>
    {children}
  </ul>
);

export const AccessibleListItem = ({ block = false, className, children, ...rest }: ListItemProps) => (
  <li className={cx(block ? listItemBlockStyle : listItemStyle, className)} {...rest}>
    {children}
  </li>
);

const listStyle = css`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const listItemStyle = css`
  display: contents;
`;

const listItemBlockStyle = css`
  display: block;
`;
